import { AssetService } from '@/api/services/AssetService';
import { AssetOverview } from '@/api';
import callWithContext from '@/api/call-with-context';
import { ToolDefinition } from '../types';

const getAssetByUrnTool: ToolDefinition = {
  name: 'get_asset_by_urn',
  description: 'Get asset details by URN. Use for specific asset details. If only name provided, use search_assets first to get URN. Returns: name, id, urn, type, healthStatus, owners, tags, terms, domains, description, schema, customMetadata. For ASSETS only (tables, dashboards, pipelines, ML models). For data products, use get_data_product_by_id. Monitors separate; use search_monitors.',
  input_schema: {
    type: 'object',
    properties: {
      urn: {
        type: 'string',
        description: 'Asset URN. Use search_assets first if only name provided.',
      },
    },
    required: ['urn'],
  },
};

/**
 * Execute the get_asset_by_urn tool
 */
export async function executeGetAssetByUrn(
  params: { urn: string },
): Promise<AssetOverview | { error: string }> {
  try {
    const result = await callWithContext('sifflet-ai-chat', () => AssetService.getAssetOverviewByUrn({
      urn: params.urn,
    }));

    return result;
  } catch (error) {
    return { error: (error as Error).message };
  }
}

export default getAssetByUrnTool;
